import { Link } from '@/atoms/Link';

export const FooterLink = ({ src, alt, href, className }: FooterLinkProps) => {
  return (
    <Link href={href}>
      <img
        loading='lazy'
        decoding='async'
        className={className}
        src={src}
        alt={alt}
      />
    </Link>
  );
};
type FooterLinkProps = {
  src: string;
  alt: string;
  href: string;
  className: string;
};
